export enum PurchaseType {
  LOTS_SALES = 'lots_sales',
  SERVICES_SALES = 'services_sales',
  SCATTERING = 'scattering',
}
